<template>
  <div id="app">
    <Container v-if="$route.meta.showHeader"></Container>
    <router-view v-if="!$route.meta.showHeader"></router-view>
  </div>
</template>

<script>
import Container from './components/Container.vue'

import { setStorage, getStorage } from '@/utils/storage'
import store from "@/store";

export default {
  name: 'App',
  components: {
    Container
  },
  mounted() {
    if (JSON.parse(getStorage('userInfo'))) {
      store.commit("changeData", {
        key: "userInfo",
        val: JSON.parse(getStorage('userInfo')).val,
      });
    }
    if (JSON.parse(getStorage('isUserLogin'))) {
      store.commit("changeData", {
        key: "isUserLogin",
        val: true,
      });
    }
  }
}
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Montserrat, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  background: #F2F2F2;
}

body {
  margin: 0;
  /* background-color: #000000; */
  -webkit-text-size-adjust: 100%;
  -webkit-tap-highlight-color: transparent;
}
</style>
